import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";

const page = usePage()

const title = computed<string>(() => {
    return (page.props.title as string) ?? 'Welcome'
})

export const useTitle = () => {
    return {
        title,
    }
}
